<template>
  <div class="addmodal fixed w-full h-full z-20 top-0 left-0 flex justify-center items-start">
    <div class="bg-white m-auto w-96 flex flex-col rounded-md justify-center items-center">
        <h2 class="font-costea w-10/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
            Crear nuevo Gasto
        </h2>
        <form @submit.prevent="validateForm" class="flex flex-col justify-start w-full items-center">
            <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 rounded-md">
                <label for="nombreGasto" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Nombre del Gasto: *</label>
                <input type="text" id="nombreGasto" v-model="nombreGasto" required class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide" placeholder="">
            </div>
            <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 rounded-md">
                <label for="costoGasto" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Gasto: *</label>
                <input type="text" id="costoGasto" v-model="costoGasto" required class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide" placeholder="">
            </div>
            <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-between">
                <button class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide" @click="toggleModal()" type="button">Cancelar</button>
                <div v-show="this.buttonText == 'Creando...'" class="bg-costeaPrimary rounded-md text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4">Creando...</div>
                <button :disabled="this.disabledButton" v-show="this.buttonText === 'Crear' || this.buttonText === '¡Listo!'" :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 '+ buttonBg + (this.buttonProcessing ? ' pointer-events-none opacity-50' : '')" type="submit">{{buttonText}}</button>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import moment from 'moment'
export default {
    data(){
        return{
            nombreGasto: '',
            costoGasto: '',
            buttonText: 'Crear',
            buttonBg: 'bg-costeaPrimary',
            modalAct : true,
            disabledButton: false,
            buttonProcessing: false
        }
    },
    mounted(){
        
    },
    computed:{...mapState(['costea'])},
    methods:{
        
        validateForm(){
          this.buttonText = 'Creando...'
          this.buttonProcessing = true
          this.setCategories()
        },

        setCategories: function(){
          let config = {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }
          axios
          .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}gasto-add`, {nombre_gasto: this.nombreGasto, gasto_mensual: this.costoGasto, fecha_de_estudio: moment().format('YYYY-MM-DD')}, config)
            .then(()=>{
                this.buttonBg = 'bg-costeaDarkGreen'
                this.buttonText = '¡Listo!'
                this.buttonProcessing = true
                this.disabledButton = true
                setTimeout(()=>{
                 this.toggleModal()
                 this.buttonText = 'Crear'
                 this.nombreGasto = ''
                this.costoGasto = ''
                    this.disabledButton = false
                    this.buttonBg = 'bg-costeaPrimary'
                    this.buttonProcessing = false
                },500)
            }
            ).catch (
                (error) => {
                  console.log(error)
                }
            );
      },
        modalActive(){
            this.modalAct = true
            this.modalAct == true ? this.modalAct = false : this.modalAct = true
            return this.modalAct
        },
        toggleModal(){
            this.$emit('closeModalAdd', this.modalActive())
            this.$emit('reloadData', true)
        },
        onProcess(){
            this.buttonText = 'Creando...'
        }
    }
}
</script>

<style scoped>
    .addmodal{
        background: rgba(0, 0, 0, 0.6);
    }
</style>